// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607220259/js/" + chunkId + "." + {"44":"10f44052","225":"1ba1ffa3","481":"f8126484","486":"f3112ae4","770":"acb3aae9"}[chunkId] + ".0.234144130651614.chunk.js";
};